<template>
  <transition name="slide-fade">
    <div class="loader" v-if="show">
      <font-awesome-icon icon="spinner" spin class="icon"/>Loading...
    </div>
  </transition>
</template>

<style lang="scss">
@import "../assets/styles/main.scss";

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter {
  transform: translateY(20px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

.loader {
  position: fixed;
  left: 50%;
  top: 10px;
  padding: 15px 100px;
  transform: translateX(-50%);
  z-index: 9999;
  text-align: center;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 20px 32px -8px rgba(9, 30, 66, 0.2),
    0 0 1px rgba(9, 30, 66, 0.31);
  font-size: 0.9rem;
  .icon {
    position: relative;
    font-size: 1rem;
    margin-right: 15px;
  }
}
</style>

<script>
export default {
  name: "Loader",
  data() {
    return {
      show: false
    };
  },
  methods: {
    showLoader() {
      this.show = true;
    },
    hideLoader() {
      this.timeout = setTimeout(() => {
        this.show = false;
      }, 100);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Loader.vue